// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format14 } from '../../constants';

import { format2 } from '../../constants';

/** Netherlands */
const NL: PhoneNumberData = [31, 'NL', 9, format14, 11, format2];

export default NL;
